import Icon from "./Icon";


const Compatibility = () => {


    const ripples = () => {

        const data = [{},{
            astra:0,
            
            beaver:180,
        },
        {
            elementor:-90,
            divi:90, 
            bricks:-55,
            oxygen:55,  
            avada:-125,
            vc:125,
            //ocean:180,
        },{empty:0},{empty:0},{empty:0},{empty:0}
            
    ]

        /* const data = [{},{
            astra:0,
            elementor:-110,
            divi:110
        },
        {
            beaver:180,
            bricks:-55,
            oxygen:55,  
        },
        {
            avada:-90,
            vc:90,
            //ocean:180,
        },{empty:0},{empty:0},{empty:0},{empty:0}
            
    ] */

        const ret = data.map((o,index)=>{
            const unit = 620 + index*200;
            const innerRipples = Object.keys(o)
            return innerRipples.map((theme,innerIndex)=>{
                const sty = innerIndex === 0 ? 'border-2 border-slate-50' : ''
                const rotation = o[theme]

                const cnt = theme === 'empty' ? '' : <div style={{transform:'rotate('+(rotation*-1)+'deg)'}} className='w-40 h-40 absolute top-0 left-1/2 -m-20 p-10  bg-white shadow-lg shadow-slate-100 rounded-full overflow-hidden'>
                    <div className='absolute inset-10 bg-slate-500 mix-blend-screen z-20'></div>
                    <img className='grayscale' src={`./animatorLogos/${theme}.png`} alt={theme} />
                </div>
                return <div id={'comp-'+index+'-'+innerIndex} key={index+'-'+innerIndex} style={{width:unit,height:unit,margin:unit*-.5,transform:'rotate('+rotation+'deg)'}} className={sty+' rounded-full absolute top-1/2 left-1/2 '}>
                    
                    {cnt}
                </div>
            })
        })


        return ret;
    }

    return <section className='p-5 lg:p-0 lg:h-screen flex items-center justify-center overflow-hidden'>
        <div className='max-w-prose text-center relative z-20 '>
            <div className='flex gap-5 justify-center'>
                <Icon name='wp' outer='bg-blue-50' inner='fill-blue-500' />
                <Icon name='logo' outer='bg-blue-50' inner='fill-blue-500' />
            </div>
            <h2>Works with your current WordPress setup</h2>
            <p className='sub'>Whether you're working with a standard WordPress Theme or a with a Page builder, the Animator plugin will work out of the box on any element on your site, with a very small footprint.</p>
        </div>
        <div className='hidden lg:block w-[600px] h-[600px] absolute top-1/2 left-1/2 -m-[300px] flex-1'>
            {ripples()}
        </div>
    </section>
  
}
export default Compatibility